import { gql } from '@apollo/client';

export default gql`
  mutation printTicketsAtb($bookingReference: String!, $itemRefs: [Int]) {
    printTicketsAtb(bookingReference: $bookingReference, itemRefs: $itemRefs) @client {
      status
    }
  }
`;
